import React, { ReactElement } from 'react';
import { GatewayProvider, LoggingProvider } from '../context';
import UniversalVideoRecorder from '../components/UniversalVideoRecorder';
import { VimeoRecorder } from '../components/Vimeo/VimeoRecorder';
import '../i18n';

interface AppProps {
  open: boolean;
  enableVimeoRecorder?: boolean;
  maxRecordTimeSeconds?: number;
  gatewayUrl?: string;
  // this is optional because we enabling the Vimeo recorder is optional
  onComplete?: (videoId?: string) => void;
  onInitialize?: () => void;
  onRecordingCancel?: () => void;
  onRecordingStart?: () => void;
  onRecordingStop?: () => void;
  // custom recorder callbacks
  getAuthToken?: () => string;
  onClose?: (video: Blob | null, filename?: string) => void;
  onProcessingComplete?: (content: string | null | Error) => void;
  onEvent?: () => void;
}

export default function App(props: AppProps): ReactElement {
  // eslint-disable-next-line
  console.log(`UVR Video Version ${UVR_VERSION}`);

  return (
    <GatewayProvider gatewayUrl={props.gatewayUrl} getAuthToken={props.getAuthToken}>
      <LoggingProvider>
        <>
          {!props.enableVimeoRecorder && (
            <UniversalVideoRecorder
              open={props.open}
              maxRecordTimeSeconds={props.maxRecordTimeSeconds}
              onClose={props.onClose}
              onProcessingComplete={props.onProcessingComplete}
              onEvent={props.onEvent}
            />
          )}
          {props.enableVimeoRecorder && (
            <VimeoRecorder
              isOpen={props.open}
              onComplete={props.onComplete}
              onInitialize={props.onInitialize}
              onRecordingCancel={props.onRecordingCancel}
              onRecordingStart={props.onRecordingStart}
              onRecordingStop={props.onRecordingStop}
            />
          )}
        </>
      </LoggingProvider>
    </GatewayProvider>
  );
}
